const defaultButtonProps = {
  bg: "white",
  borderRadius: "base",
  fontWeight: "600",
  py: 0,
  px: "12px",

  rounded: "md",
  h: "button",
  transition: "transform 0.1s ease, background-color 0.1s ease",
  transformOrigin: "center",
  _hover: {
    transform: "scale(1.1)",
  },
  _disabled: {
    transform: "none !important",
  },
};

export const BUTTON_STYLES = {
  variants: {
    primary: {
      ...defaultButtonProps,
      bg: "primaryBg",
      color: "white",
    },
    outlinePrimary: {
      ...defaultButtonProps,
      color: "primary",
      border: "solid 2px",
      borderColor: "primary",
      bg: "softBg",
    },
    outlinePrimarySmall: {
      ...defaultButtonProps,
      color: "primary",
      borderColor: "primary",
      border: "solid 1px",
      padding: "0",
      height: "fit-content",
      minHeight: "8",
      minWidth: "8",
    },
    accent: {
      ...defaultButtonProps,
      bg: "transparent",
      color: "accent",
    },
    ghost: {
      ...defaultButtonProps,
      bg: "transparent",
      color: "text",
      fontWeight: "400",
      _hover: {
        ...defaultButtonProps._hover,
        bg: "accentLight",
      },
    },
    outlineGrey: {
      ...defaultButtonProps,
      bg: "white",
      color: "grey",
      border: "solid 2px",
      borderColor: "grey",
    },
    search: {
      ...defaultButtonProps,
      bg: "white",
      color: "black",
      boxShadow: "2px 2px 2px #00000029",
      border: "solid 1px #00000029",
    },
  },
};
